import api from "@/api";
import { ElMessage } from "element-plus";
import EmdEnumValueListView from "@/views/manager/EmdEnumValueListView.vue";
export default {
  name: "FriendNoticeView",
  components: {
    EmdEnumValueListView
  },
  data() {
    return {
      tab: '-',
      sites: []
    };
  },
  methods: {
    gotoEdit(d) {
      window.open('/html/edit/' + d.id, '_blank');
    },
    saveHtml(site, html) {
      api.getEnumOptionList(8, false, site.value).then(ret => {
        if (ret && ret.length > 0) {
          api.updateEnumValue({
            id: ret[0].value,
            refId: site.value,
            sortIndex: 0,
            name: site.label,
            extra: {
              html: html
            }
          }).then(() => {
            ElMessage.success('更新成功');
          });
        } else {
          api.createEnumValue({
            type: 'FRIEND_NOTICE',
            refId: site.value,
            sortIndex: 0,
            name: site.label,
            extra: {
              html: html
            }
          }).then(() => {
            ElMessage.success('新增成功');
          });
        }
      });
    },
    init() {
      api.getEnumOptionList(4, true).then(ret => {
        this.sites = ret;
        this.tab = ret.length > 0 ? ret[0].label : '-';
      });
    }
  },
  mounted() {
    this.init();
  }
};